import React from 'react';
import Hero from '../components/Hero';
import TripFinderMatrix from '../components/TripFinderMatrix';
import BurnScale from '../components/BurnScale';
import FeaturedTrips from '../components/FeaturedTrips';
import ImpactCounter from '../components/ImpactCounter';
import Partners from '../components/Partners';
import NewsletterSignup from '../components/NewsletterSignup';
import CTASection from '../components/CTASection';

const Home = () => {
  return (
    <div className="min-h-screen" data-testid="home-page">
      {/* Hero Section with Tagline */}
      <Hero />
      
      {/* Trip Finder Matrix - Region × Vibe */}
      <TripFinderMatrix />
      
      {/* Burn Scale Explanation */}
      <BurnScale />
      
      {/* Featured Trips with Burn Levels */}
      <FeaturedTrips />
      
      {/* Impact Counter Stats */}
      <ImpactCounter />
      
      {/* Partners Section */}
      <Partners />
      
      {/* Newsletter Signup */}
      <NewsletterSignup />
      
      {/* Final CTA */}
      <CTASection />
    </div>
  );
};

export default Home;
